

$( ".MenuTop .is-top.dropdown > a" ).click(function(e) {
    e.preventDefault();
    // hide any existing sub menus
    $( ".MenuTop .is-top.dropdown .dropdown-menu" ).hide();
    // show the sub menu we clicked
    $(this).parent().find(".dropdown-menu").show();
  });

$( "body" ).click(function(e) {
    // if we click anywhere other than the top menu link then close any open sub menus
    if(e.target.className !== 'MenuTop-item-link') {
        $( ".MenuTop .is-top.dropdown .dropdown-menu" ).hide();
    }
  });